import styled from "@emotion/styled";
import Link from "@mui/material/Link";

const LinkContainer = styled.div`
  margin-top: 5px;
`;
export default function DonateLink() {
  return (
    <LinkContainer className="donateLinkContainer">
      If you enjoy using this calculator,{" "}
      <Link
        href="https://www.buymeacoffee.com/cjwilson"
        target="_blank"
        rel="noopener"
      >
        consider buying me a coffee!
      </Link>
    </LinkContainer>
  );
}
